import { render, staticRenderFns } from "./formatcurrency.vue?vue&type=template&id=29f78cb5&"
import script from "./formatcurrency.vue?vue&type=script&lang=js&"
export * from "./formatcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f78cb5')) {
      api.createRecord('29f78cb5', component.options)
    } else {
      api.reload('29f78cb5', component.options)
    }
    module.hot.accept("./formatcurrency.vue?vue&type=template&id=29f78cb5&", function () {
      api.rerender('29f78cb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/formatcurrency.vue"
export default component.exports